export default "__VITE_ASSET__DR8oV9qp__"